import { useState } from "react";
import { className } from '../../../../Utils';

import AccordionHeader from "./AccordionHeader";
import AccordionContentDesktop from "./AccordionContentDesktop";
import AccordionVideo from "./AccordionVideo";

import "./Accordion.css";

const Accordion = ({ data, title, videoUrl, freeFunctionality, isOpen, setOpenAccordion }) => {
    const [isOpenVideo, setIsOpenVideo] = useState(false);

    return (
        <main>
            <div className={className("container")}>
                <div className={className('container-accordion-video-wrapper')}>
                    <AccordionVideo
                        videoUrl={videoUrl}
                        isOpenVideo={isOpenVideo}
                        SetIsOpenVideoHandler={setIsOpenVideo}
                        title={title}
                    />
                </div>


                <section className={className('info')}>
                    <AccordionHeader
                        title={title}
                        SetIsOpenVideoHandler={setIsOpenVideo}
                        setOpenAccordion={setOpenAccordion}
                        data={data}
                        freeFunctionality={freeFunctionality}
                        videoUrl={videoUrl}
                    />

                    {isOpen && (
                        <div>
                            {data.map((item) => (
                                <AccordionContentDesktop
                                    key={item.id}
                                    itemTitle={item.title}
                                    content={item.content}
                                    freeFunctionality={freeFunctionality}
                                />

                            ))}
                        </div>
                    )}
                    {/* {data.length % 2 !== 0 && <div className={className('accordion-line-end')} />} */}
                </section>
            </div>
        </main>
    );
};

export default Accordion;